export default __webpack_public_path__ + "static/media/payment-failed.f68e8bd2.jpg";